import {ReactNode} from "react";
import {css} from "@panda/css";

import {Text} from "@pg-design/text-module";
import {REGISTRATION_WIZARD_TEST_IDS} from "@pg-mono/test-ids";

interface IProps {
    titleId: string;
    title: string;
    description?: ReactNode;
    children: ReactNode;
}

export const RegistrationWizardStepLayout = (props: IProps) => {
    const {titleId, title, description, children} = props;

    return (
        <div className={layoutStyle}>
            <div className={titleSectionStyle}>
                <Text as="h2" variant="headline_4" id={titleId} dataTestId={REGISTRATION_WIZARD_TEST_IDS.STEP_TITLE}>
                    {title}
                </Text>
                {description && (
                    <Text as="p" variant="body_copy_2" className={descriptionStyle}>
                        {description}
                    </Text>
                )}
            </div>

            {children}
        </div>
    );
};

const layoutStyle = css({
    display: "flex",
    flexDirection: "column",
    rowGap: 3,
    px: 2,
    pt: 1.5,
    pb: 3,
    md: {
        px: 3,
        pt: 3,
        pb: 3
    }
});

const titleSectionStyle = css({
    display: "flex",
    flexDirection: "column",
    rowGap: 1,
    color: "var(--colors-secondary)",
    md: {
        rowGap: 1.5
    }
});

const descriptionStyle = css({
    color: "var(--colors-gray-800)",
    md: {
        color: "var(--colors-gray-700)"
    }
});
import {ReactNode} from "react";
import {css} from "@panda/css";

import {Text} from "@pg-design/text-module";
import {REGISTRATION_WIZARD_TEST_IDS} from "@pg-mono/test-ids";

interface IProps {
    titleId: string;
    title: string;
    description?: ReactNode;
    children: ReactNode;
}

export const RegistrationWizardStepLayout = (props: IProps) => {
    const {titleId, title, description, children} = props;

    return (
        <div className={layoutStyle}>
            <div className={titleSectionStyle}>
                <Text as="h2" variant="headline_4" id={titleId} dataTestId={REGISTRATION_WIZARD_TEST_IDS.STEP_TITLE}>
                    {title}
                </Text>
                {description && (
                    <Text as="p" variant="body_copy_2" className={descriptionStyle}>
                        {description}
                    </Text>
                )}
            </div>

            {children}
        </div>
    );
};

const layoutStyle = css({
    display: "flex",
    flexDirection: "column",
    rowGap: 3,
    px: 2,
    pt: 1.5,
    pb: 3,
    md: {
        px: 3,
        pt: 3,
        pb: 3
    }
});

const titleSectionStyle = css({
    display: "flex",
    flexDirection: "column",
    rowGap: 1,
    color: "var(--colors-secondary)",
    md: {
        rowGap: 1.5
    }
});

const descriptionStyle = css({
    color: "var(--colors-gray-800)",
    md: {
        color: "var(--colors-gray-700)"
    }
});
